<template>
    <transition appear enter-active-class="animated bounceInRight">
        <f7-view main>
            <f7-page>
                <!-- header -->
                <cm-navbar :title="$ml.get('changeview')">
                    <f7-nav-right><f7-link @click="save">{{ $ml.get('save') }}</f7-link></f7-nav-right>
                </cm-navbar>
                <!-- END header -->

                <!-- body -->
                <f7-block-title>{{ $ml.get('whoyouare') }}</f7-block-title>
                <f7-list>
                    <f7-list-item v-for="(item, index) in listRoles" radio name="role"
                        :key="index"
                        :value="item.id"
                        :title="item.name"
                        :checked="checked(item.id)"
                        @change="form.id = $event.target.value"></f7-list-item>
                </f7-list>
                <!-- END body -->
            </f7-page>
        </f7-view>
    </transition>
</template>

<script>
    import CMNavbar from './Navbar'
    import Query    from '@/services/api/Query'
    import Mutation from '@/services/api/Mutation'

    export default {
        name: 'ChangeView',
        components: {
            'cm-navbar': CMNavbar,
        },
        data() {
            return {
                employee_id: null,
                customer_id: null,
                listRoles: [],
                form: {
                    id: null,
                },
            }
        },

        methods: {
            checked(id) {
                let selected = false;
                if (this.customer_id && id == 'customer-' + this.customer_id) {
                    selected = true
                    this.form.id = id
                } else if (this.employee_id && id == 'employee-' + this.employee_id) {
                    this.form.id = id
                    selected = true
                }

                return selected
            },

            async save() {
                if (! this.form.id)
                    return this.$f7.dialog.alert(this.$ml.get('errors.requiredAll'), this.$ml.get('errors.title'))

                this.$f7.dialog.preloader(this.$ml.get('processing'))
                let result  = await Mutation.changeView(this.form.id).execute()

                if (result.data.errors) {
                    let message = this.$helper.errors(result.data.errors)
                    this.$f7.dialog.close()

                    return this.$f7.dialog.alert(message, this.$ml.get('errors.title'))
                }

                this.$f7.dialog.close()
                let data = this.$helper.data(result, 'change_view')
                if (localStorage.userLogin) {
                    let userLogin = JSON.parse(localStorage.userLogin)
                    userLogin.employee_id  = data.employee_id
                    userLogin.customer_id  = data.customer_id
                    localStorage.userLogin = JSON.stringify(userLogin)
                }
                return this.$f7.dialog.alert(this.$ml.get('success.changeRole'), this.$ml.get('information'))
            },
        },

        async created() {
            this.listRoles = this.$helper.data(await Query.withListChangeViews().get(), 'list_change_views')

            if (localStorage.userLogin) {
                let userLogin = JSON.parse(localStorage.userLogin)
                this.employee_id = userLogin.employee_id
                this.customer_id = userLogin.customer_id
            }
        },
    }
</script>